/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';
import '../vendors/gsap.min';
import Draggable from '../vendors/Draggable.min';
import '../vendors/ScrollTrigger.min';
import '../vendors/ScrollSmoother.min';
import DrawSVGPlugin from '../vendors/DrawSVGPlugin.min';
import ScrollReveal from '../vendors/scrollreveal';
import SplitText from '../vendors/SplitText.min';
import './search-ajax';
import Typed from '../vendors/typed.min.js';

let lastScrollTop = 0,
	delta = 15;
jQuery( window ).on( 'scroll', function( event ) {
	if ( jQuery( window ).width() > 1003 ) {
		const headerHight = -1 * parseInt( jQuery( '.header-section' ).height() );
		let adjustment = 0;
		if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
			adjustment = 32;
		}

		if ( jQuery( window ).width() < 783 ) {
			adjustment = 46;
		}

		const st = jQuery( this ).scrollTop();
		if ( Math.abs( lastScrollTop - st ) <= delta ) {
			return;
		}
		if ( st > lastScrollTop && lastScrollTop > 50 ) {
			jQuery( 'header,body' ).addClass( 'nav-up' );
			jQuery( 'header,body' ).removeClass( 'nav-down' );
			jQuery( '.header-section' ).css( 'top', headerHight + adjustment );
			jQuery( '.hero-fixed-nav-ctn' ).css( 'top', 0 + adjustment );
		} else {
			jQuery( 'header,body' ).removeClass( 'nav-up' );
			jQuery( 'header,body' ).addClass( 'nav-down' );
			jQuery( '.header-section' ).css( 'top', 0 + adjustment );
			jQuery( '.hero-fixed-nav-ctn' ).css( 'top', -headerHight + adjustment );
		}
		lastScrollTop = st;
	}

	if ( jQuery( document ).scrollTop() > 50 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );
jQuery.noConflict();

jQuery( window ).on( 'load resize', function() {
	const $topBar_height = jQuery( '.top-bar' ).outerHeight();
	const $header_height = jQuery( '.header-section' ).outerHeight();
	const $header_wrapper = jQuery( '.header-inner' ).outerHeight();
	const $wpAdminBar = jQuery( '#wpadminbar' ).outerHeight();
	const $paddingTopValue = jQuery( '.hero--home' ).css( 'padding-top' );
	const $homePaddingWithLogin = $paddingTopValue - $topBar_height - $wpAdminBar;
	const $homePaddingWithoutLogin = $paddingTopValue - $topBar_height;

	const $adminTopbar = $header_wrapper + $topBar_height;
	const $headerTopbar = $header_wrapper + $topBar_height;
	const $headerTopbarAdmin = ( $header_wrapper + $topBar_height + $wpAdminBar );

	// Update styles for .hero-section
	jQuery( '.hero-section' ).css( 'padding-top', $header_height + 'px' );
	// Update styles for elements with classes .have-topbar and .hide-topbar
	jQuery( '.have-topbar .hero-section' ).css( 'padding-top', $header_height + 'px' );

	jQuery( '.progress-container' ).css( 'top', $header_height + 'px' );
	jQuery( '.logged-in.admin-bar  .progress-container' ).css( 'top', $header_height + $wpAdminBar + 'px' );
	jQuery( '.have-topbar.logged-in.admin-bar  .progress-container' ).css( 'top', $header_wrapper + $wpAdminBar + $topBar_height + 'px' );

	jQuery( '.nav-overlay' ).css( 'padding-top', '0' );
	jQuery( '.open-mega-menu-button' ).hide();

	if ( jQuery( window ).width() > 1179 ) {
		jQuery( '.nav-overlay' ).css( 'padding-top', '0' );
	}
	if ( jQuery( window ).width() > 782 ) {
		if ( jQuery( window ).width() < 1179 ) {
			jQuery( '.nav-overlay' ).css( 'padding-top', $header_wrapper + 'px' );
			jQuery( '.logged-in.admin-bar .nav-overlay' ).css( 'padding-top', $header_wrapper + $wpAdminBar + 'px' );
			jQuery( '.have-topbar .nav-overlay' ).css( 'padding-top', $header_wrapper + $topBar_height + 'px' );
			jQuery( '.have-topbar.logged-in.admin-bar .nav-overlay' ).css( 'padding-top', $headerTopbarAdmin + 'px' );

			jQuery( '.mega-menu' ).css( 'top', $header_wrapper + 'px' );
			jQuery( '.logged-in.admin-bar .mega-menu' ).css( 'top', $header_wrapper + $wpAdminBar + 'px' );
			jQuery( '.have-topbar .mega-menu' ).css( 'top', $header_wrapper + $topBar_height + 'px' );
			jQuery( '.have-topbar.logged-in.admin-bar .mega-menu' ).css( 'top', $headerTopbarAdmin + 'px' );

			jQuery( '.header-search-form' ).css( 'top', $header_wrapper + 20 + 'px' );
			jQuery( '.logged-in.admin-bar .header-search-form' ).css( 'top', $headerTopbarAdmin + 20 + 'px' );

			jQuery( '.header-search-form' ).css( 'top', $header_wrapper + 20 + 'px' );
			jQuery( '.logged-in.admin-bar .header-search-form' ).css( 'top', $header_wrapper + $wpAdminBar + 20 + 'px' );
			jQuery( '.have-topbar .header-search-form' ).css( 'top', $header_wrapper + $topBar_height + 20 + 'px' );
			jQuery( '.have-topbar.logged-in.admin-bar  .header-search-form' ).css( 'top', $header_wrapper + $wpAdminBar + $topBar_height + 20 + 'px' );
		}

		jQuery( '.top-bar-cross' ).on( 'click', function() {
			jQuery( '.top-bar' ).addClass( 'hide-top-bar' );
			jQuery( '.hero-section' ).css( 'padding-top', $header_wrapper + 'px' );
			jQuery( '.progress-container' ).css( 'top', $header_wrapper + 'px' );
			jQuery( '.logged-in.admin-bar .progress-container' ).css( 'top', $header_wrapper + $wpAdminBar + 'px' );

			jQuery( '.hero-fixed-nav-ctn' ).css( 'top', $header_wrapper + 'px' );
			jQuery( '.logged-in.admin-bar  .hero-fixed-nav-ctn' ).css( 'top', $header_wrapper + $wpAdminBar + 'px' );

			// nav overlay values
			if ( jQuery( window ).width() < 1179 ) {
				jQuery( '.hide-topbar .nav-overlay' ).css( 'padding-top', ( $headerTopbar - $topBar_height ) + 'px' );
				jQuery( '.hide-topbar.logged-in.admin-bar .nav-overlay' ).css( 'padding-top', ( $headerTopbarAdmin - $topBar_height ) + 'px' );
				jQuery( '.header-search-form' ).css( 'top', $header_wrapper + 20 + 'px' );
				jQuery( '.logged-in.admin-bar .header-search-form' ).css( 'top', $header_wrapper + $wpAdminBar + 20 + 'px' );
				jQuery( '.have-topbar .header-search-form' ).css( 'top', $header_wrapper + $topBar_height + 'px' );
				jQuery( '.have-topbar.logged-in.admin-bar  .header-search-form' ).css( 'top', $header_wrapper + $topBar_height + $wpAdminBar + 20 + 'px' );
			}

			jQuery( '.mega-menu' ).css( 'top', $header_wrapper + 'px' );
			jQuery( '.hide-topbar .mega-menu' ).css( 'top', $header_wrapper + 'px' );
			jQuery( '.hide-topbar.logged-in.admin-bar .mega-menu' ).css( 'top', $header_wrapper + $wpAdminBar + 'px' );
			jQuery( '.hero-section' ).css( 'padding-top', $header_wrapper - $topBar_height + 'px' );
		} );
	}

	if ( jQuery( window ).width() < 783 ) {
		jQuery( '.nav-overlay' ).css( 'padding-top', $header_wrapper + 'px' );
		jQuery( '.logged-in.admin-bar .nav-overlay' ).css( 'padding-top', $header_wrapper + $wpAdminBar + 'px' );
		jQuery( '.have-topbar .nav-overlay' ).css( 'padding-top', $header_wrapper + $topBar_height + 'px' );
		jQuery( '.have-topbar.logged-in.admin-bar .nav-overlay' ).css( 'padding-top', $headerTopbarAdmin + 'px' );

		jQuery( '.mega-menu' ).css( 'top', $header_wrapper + 'px' );
		jQuery( '.logged-in.admin-bar .mega-menu' ).css( 'top', $header_wrapper + $wpAdminBar + 'px' );
		jQuery( '.have-topbar .mega-menu' ).css( 'top', $header_wrapper + $topBar_height + 'px' );
		jQuery( '.have-topbar.logged-in.admin-bar .mega-menu' ).css( 'top', $headerTopbarAdmin + 'px' );

		jQuery( '.header-search-form' ).css( 'top', $header_wrapper + 20 + 'px' );
		jQuery( '.logged-in.admin-bar .header-search-form' ).css( 'top', $headerTopbarAdmin + 20 + 'px' );

		jQuery( '.header-search-form' ).css( 'top', $header_wrapper + 20 + 'px' );
		jQuery( '.logged-in.admin-bar .header-search-form' ).css( 'top', $header_wrapper + $wpAdminBar + 20 + 'px' );
		jQuery( '.have-topbar .header-search-form' ).css( 'top', $header_wrapper + $topBar_height + 20 + 'px' );
		jQuery( '.have-topbar.logged-in.admin-bar  .header-search-form' ).css( 'top', $header_wrapper + $wpAdminBar + $topBar_height + 20 + 'px' );
		jQuery( '.open-mega-menu-button' ).show();

		jQuery( '.top-bar-cross' ).on( 'click', function() {
			jQuery( '.have-topbar header' ).css( 'top', '-' + $topBar_height + 'px' );
			jQuery( '.logged-in.admin-bar header' ).css( 'top', '-' + $topBar_height + 'px' );
			jQuery( '.mega-menu' ).css( 'top', $header_wrapper + 'px' );
			jQuery( '.hide-topbar .mega-menu' ).css( 'top', $header_wrapper + 'px' );
			jQuery( '.hide-topbar.logged-in.admin-bar .mega-menu' ).css( 'top', $header_wrapper + $wpAdminBar + 'px' );
			jQuery( '.hero-section' ).css( 'padding-top', $header_wrapper - $topBar_height + 'px' );

			jQuery( '.header-search-form' ).css( 'top', $header_wrapper + 20 + 'px' );
			jQuery( '.logged-in.admin-bar .header-search-form' ).css( 'top', $header_wrapper + $wpAdminBar + 20 + 'px' );
			jQuery( '.have-topbar .header-search-form' ).css( 'top', $header_wrapper + $topBar_height + 'px' );
			jQuery( '.have-topbar.logged-in.admin-bar  .header-search-form' ).css( 'top', $header_wrapper + $topBar_height + $wpAdminBar + 20 + 'px' );

			// nav overlay values
			jQuery( '.hide-topbar .nav-overlay' ).css( 'padding-top', ( $headerTopbar - $topBar_height ) + 'px' );
			jQuery( '.hide-topbar.logged-in.admin-bar .nav-overlay' ).css( 'padding-top', ( $headerTopbarAdmin - $topBar_height ) + 'px' );
		} );

		if ( jQuery( window ).width() < 517 ) {
			if ( jQuery( 'body' ).hasClass( 'logged-in admin-bar' ) ) {
				const $loggedInHeight = $topBar_height - $wpAdminBar;
				jQuery( '.top-bar-cross' ).on( 'click', function() {
					jQuery( 'header' ).css( 'top', '-' + $loggedInHeight + 'px' );
				} );
			}
		}
	}
} );

jQuery( function() {
	if ( jQuery( '.sliderthemegridtop' ) && jQuery( '.sliderthemegridbottom' ).length > 0 ) {
		const $themeSliderTop = jQuery( '.sliderthemegridtop .slide-track .slide' );
		const $themeSliderbottom = jQuery( '.sliderthemegridbottom .slide-track .slide' );

	    const elementCountTop = $themeSliderTop.length;
	    const elementCountBottom = $themeSliderbottom.length;
	    jQuery( ':root' ).css( '--theme-slider-top', elementCountTop );
	    jQuery( ':root' ).css( '--theme-slider-top-half', elementCountTop / 2 );
	    jQuery( ':root' ).css( '--theme-slider-bottom', elementCountBottom );
	    jQuery( ':root' ).css( '--theme-slider-bottom-half', elementCountBottom / 2 );
	}

	if ( jQuery( '.js-mongoose-slider' ).length > 0 ) {
		// Function to check if an element is in the viewport
		function isElementInViewport( el ) {
			const rect = el.getBoundingClientRect();
			return (
				rect.right >= 0 && // Element is at least partially in the viewport from the left.
				rect.left <= window.innerWidth * 0.4 // Element is up to 30% from the right.
			);
		}
		// Function to add the "draw-svg" class to an element
		function addDrawSvgClass( entries ) {
			entries.forEach( ( entry ) => {
				const element = entry.target;
				const isIntersecting = entry.isIntersecting;
				const svgElement = element.querySelector( '.mongoose-design-element' );

				if ( isIntersecting ) {
					svgElement.classList.add( 'draw-svg' );
				} else {
					svgElement.classList.remove( 'draw-svg' );
				}
			} );
		}

		// Create an Intersection Observer to monitor .slick-slide elements
		const observer = new IntersectionObserver( addDrawSvgClass, {
			root: null,
			rootMargin: '0px',
			threshold: 0.3, // Trigger when 30% of the target is visible
		} );

		// Observe all .slick-slide elements
		document.querySelectorAll( '.slick-slide' ).forEach( ( slide ) => {
			observer.observe( slide );
		} );

		// In addition, observe DOM mutations to check for changes in .mongoose-design-element
		const mutationObserver = new MutationObserver( () => {
			// Update the Intersection Observer when there are changes in the DOM
			document.querySelectorAll( '.slick-slide' ).forEach( ( slide ) => {
				observer.observe( slide );
			} );
		} );

		mutationObserver.observe( document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			characterData: true,
		} );
	}

	if ( jQuery( '.textSwapSlider' ).length > 0 ) {
		const typing = new Typed( '.textSwapSlider', {
			strings: jQuery( '.textSwapSlider' ).attr( 'data-text' ).split( ',' ),
			typeSpeed: 100,
			backSpeed: 40,
			loop: true,
		} );
	}

	if ( jQuery( window ).width() < 1180 ) {
		jQuery( '.header-search-form' ).on( 'focus', ':input', function() {
			jQuery( 'body' ).addClass( 'focused' );
		} );
		// Remove the class from the parent element when focus is lost.
		jQuery( '.header-search-form' ).on( 'blur', ':input', function() {
			jQuery( 'body' ).removeClass( 'focused' );
		} );
	}

	jQuery( '.video-popup' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		autoplay: true,
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,

	} );

	if ( jQuery( window ).width() < 1180 ) {
		const menuMobileIconAppend = `<button class="open-mega-menu-button"></button>`;
		const closeMenuMobileIconAppend = `<button class="close-mega-menu-button have-no-button-style">Platform</button>`;

		jQuery( '.have-mega-menu' ).each( function() {
			jQuery( this ).prepend( menuMobileIconAppend );
		} );

		jQuery( '.mega-menu' ).each( function() {
			jQuery( this ).prepend( closeMenuMobileIconAppend );
		} );

		jQuery( '.open-mega-menu-button' ).on( 'click', function() {
			jQuery( this ).siblings( '.mega-menu' ).addClass( 'show-mega-menu' );
			jQuery( 'body' ).addClass( 'show-mega-menu' );
		} );

		jQuery( '.close-mega-menu-button' ).on( 'click', function() {
			jQuery( '.mega-menu' ).removeClass( 'show-mega-menu' );
			jQuery( 'body' ).removeClass( 'show-mega-menu' );
			document.activeElement.blur();
		} );

		jQuery( document ).on( 'click', '.close-mega-menu-button , .menu-btn', function() {
			jQuery( '.mega-menu' ).removeClass( 'show-mega-menu' );
			jQuery( 'body' ).removeClass( 'show-mega-menu' );
		} );
	}

	if ( jQuery( '.hero-fixed-nav-ctn' ).length > 0 ) {
		gsap.to( '.hero-fixed-nav-ctn',
			{
				ease: 'none',
				scrollTrigger: {
					trigger: '.hero-resources-detail',
					start: 'top top',
					end: 'bottom 20%',
					// markers: true,
					onEnter: () => {
						jQuery( '.hero-fixed-nav-ctn' ).addClass( 'show-element' );
						jQuery( '.progress-container-initial' ).addClass( 'hide-when-fixed' );
					},
					onLeaveBack: () => {
						jQuery( '.hero-fixed-nav-ctn' ).removeClass( 'show-element' );
						jQuery( '.progress-container-initial' ).removeClass( 'hide-when-fixed' );
					},
				},
			}
		);
	}

	gsap.registerPlugin( DrawSVGPlugin );
	if ( jQuery( '.infinite-animation-mid' ).length > 0 ) {
		const infiniteAnimations = gsap.utils.toArray( '.infinite-animation-mid' );

		infiniteAnimations.forEach( ( infiniteAnimation ) => {
			const paths = gsap.utils.toArray( infiniteAnimation.querySelectorAll( 'path' ) );

			paths.forEach( ( path, i ) => {
				gsap.fromTo(
					path,
					{
						opacity: 0,
						duration: 1,
					},
					{
						duration: 1,
						opacity: 1,
						scrollTrigger: {
							trigger: infiniteAnimation,
							start: 'top 50%',
							end: 'bottom 20%',
						},
						delay: i * 0.5,
						stagger: 1,
					}
				);
			} );
		} );
	}

	if ( jQuery( '.infinite-animation' ).length > 0 ) {
		const infiniteAnimations = gsap.utils.toArray( '.infinite-animation' );

		infiniteAnimations.forEach( ( infiniteAnimation ) => {
			const paths = gsap.utils.toArray( infiniteAnimation.querySelectorAll( 'path' ) );

			paths.forEach( ( path, i ) => {
				gsap.fromTo(
					path,
					{
						opacity: 0,
						duration: 1,
					},
					{
						duration: 1,
						opacity: 1,
						scrollTrigger: {
							trigger: infiniteAnimation,
							start: 'top 100%',
							end: 'bottom 20%',
						},
						delay: i * 0.5,
						stagger: 1,
					}
				);
			} );
		} );
	}

	if ( jQuery( '.draw-illustration' ).length > 0 ) {
		const svgItems = gsap.utils.toArray( '.draw-illustration-leadparagraph' );
		svgItems.forEach( ( svgItem, i ) => {
			gsap.fromTo(
				svgItem,
				{
					duration: 0.5,
					drawSVG: '100% 100%',
				},
				{
					drawSVG: '100% 0',
					ease: 'none',
					duration: 1.5,
					delay: 1,
					scrollTrigger: {
						trigger: svgItem,
						start: 'top center',
						end: 'bottom 20%',
					},
				}
			);
		} );
	}

	if ( jQuery( '.draw-illustration-mid' ).length > 0 ) {
		const svgItems = gsap.utils.toArray( '.draw-illustration-mid' );
		svgItems.forEach( ( svgItem, i ) => {
			gsap.fromTo(
				svgItem,
				{
					duration: 0.5,
					drawSVG: '100% 100%',
				},
				{
					drawSVG: '100% 0',
					ease: 'none',
					duration: 1.5,
					// delay: 1,
					scrollTrigger: {
						trigger: svgItem,
						start: 'top 50%',
						end: 'bottom 20%',
					},
				}
			);
		} );
	}

	if ( jQuery( '.draw-illustration' ).length > 0 ) {
		const svgItems = gsap.utils.toArray( '.draw-illustration' );
		svgItems.forEach( ( svgItem, i ) => {
			gsap.fromTo(
				svgItem,
				{
					duration: 0.5,
					drawSVG: '100% 100%',
				},
				{
					drawSVG: '100% 0',
					ease: 'none',
					duration: 1.5,
					delay: 1,
					scrollTrigger: {
						trigger: svgItem,
						start: 'top 100%',
						end: 'bottom 20%',
					},
				}
			);
		} );
	}

	if ( jQuery( '.draw-illustration1' ).length > 0 ) {
		const svgItems1 = gsap.utils.toArray( '.draw-illustration1' );
		svgItems1.forEach( ( svgItem, i ) => {
			gsap.fromTo(
				svgItem,
				{
					duration: '0.5',
					drawSVG: '0',
				},
				{
					drawSVG: '100%',
					ease: 'none',
					duration: 1.5,
					delay: 1,
					scrollTrigger: {
						trigger: svgItem,
						start: 'top 100%',
						end: 'bottom 20%',
					},
				}
			);
		} );
	}

	if ( jQuery( '.draw-illustration2' ).length > 0 ) {
		const svgItems2 = gsap.utils.toArray( '.draw-illustration2' );
		svgItems2.forEach( ( svgItem, i ) => {
			gsap.fromTo(
				svgItem,
				{
					duration: '0.5',
					drawSVG: '0',
				},
				{
					drawSVG: '100%',
					ease: 'none',
					duration: .5,
					delay: 2.5,
					scrollTrigger: {
						trigger: svgItem,
						start: 'top 100%',
						end: 'bottom 20%',
					},
				}
			);
		} );
	}

	if ( jQuery( '.draw-illustration3' ).length > 0 ) {
		const svgItems3 = gsap.utils.toArray( '.draw-illustration3' );
		svgItems3.forEach( ( svgItem, i ) => {
			gsap.fromTo(
				svgItem,
				{
					duration: 0.5,
					drawSVG: '100% 100%',
				},
				{
					drawSVG: '100% 0',
					ease: 'none',
					duration: 1.5,
					delay: 1,
					scrollTrigger: {
						trigger: svgItem,
						start: 'top 100%',
						end: 'bottom 20%',
					},
				}
			);
		} );
	}

	/**
	 * Video lenth and remaining time
	 */

	let totalDurationSeconds = 0;

	jQuery( 'video' ).each( function( index, video ) {
		video.addEventListener( 'loadedmetadata', function() {
			totalDurationSeconds = video.duration;
		} );
	} );

	jQuery( 'video' ).on( 'loadedmetadata', function() {
		function secondsToHms( d ) {
			d = Number( d );
			let timelabel = 'sec';
			const h = Math.floor( d / 3600 );
			const m = Math.floor( d % 3600 / 60 );
			const s = Math.floor( d % 3600 % 60 );

			const hDisplay = h > 0 ? h + ( h == 1 ? ' : ' : ' : ' ) : '';
			const mDisplay = m > 0 ? m + ( m == 1 ? ' : ' : ' : ' ) : '';
			const sDisplay = s > 0 ? s + ( s == 1 ? ' ' : ' ' ) : '';

			if ( d > 3600 ) {
				timelabel = 'hour';
			} else if ( d > 60 && d < 3600 ) {
				timelabel = 'min';
			} else if ( d < 60 ) {
				timelabel = 'sec';
			}

			return hDisplay + mDisplay + sDisplay + timelabel;
		}

		jQuery( this ).parent().find( '.play-btn-video-length' ).text( secondsToHms( totalDurationSeconds ) );
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav .submenu-icon' ).on( 'click', function() {
		const link = jQuery( this );
		const closestUl = link.closest( 'ul' );
		const parallelActiveLinks = closestUl.find( '.active' );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );
		let count = 0;

		closestUl.find( 'ul' ).slideUp( function() {
			if ( ++count === closestUl.find( 'ul' ).length ) {
				parallelActiveLinks.removeClass( 'active' );
			}
		} );

		if ( ! linkStatus ) {
			closestLi.children( 'ul' ).slideDown();
			closestLi.addClass( 'active' );
		}
	} );

	// Search page search value empty on button click
	jQuery( '.show-always .js-search-close' ).on( 'click', function() {
		jQuery( this ).closest( '.header-search-form' ).find( 'input[type="search"]' ).val( '' );
	} );

	/**
	 *
	 * * Video Popup
	 *
	 *
	 */

	jQuery( 'button.play-btn.playInBox' ).addClass( 'video-playing' );

	jQuery( 'button.play-btn.playInBox' ).on( 'click', function() {
		const video = jQuery( this ).prev( 'video' )[ 0 ];
		if ( video.paused ) {
			video.play();
		} else {
			video.pause();
		}

		jQuery( this ).toggleClass( 'video-playing' );
	} );

	/**
	 *
	 * * FAQs
	 *
	 *
	 */

	jQuery( '.faq__single span' ).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
			jQuery( this ).closest( '.faq__single' ).removeClass( 'active' );
			jQuery( this )
				.siblings( '.faq__content' )
				.slideUp( 300 );
		} else {
			jQuery( '.faq__single span' ).removeClass( 'active' );
			jQuery( '.faq__single' ).removeClass( 'active' );
			jQuery( this ).closest( '.faq__single' ).addClass( 'active' );
			jQuery( '.faq__content' ).slideUp( 300 );
			jQuery( this ).addClass( 'active' );
			jQuery( this )
				.siblings( '.faq__content' )
				.slideDown( 300 );
		}
	} );

	/**
	 *
	 * * Tabbed Content Mobile accordian
	 *
	 *
	 */

	jQuery( '.mobile-title' ).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
			jQuery( this ).closest( '.mobile-title' ).removeClass( 'active' );
			jQuery( this )
				.siblings( '.tabbed-content-row' )
				.slideUp( 300 );
		} else {
			jQuery( '.mobile-title' ).removeClass( 'active' );
			jQuery( '.mobile-title' ).removeClass( 'active' );
			jQuery( this ).closest( '.mobile-title' ).addClass( 'active' );
			jQuery( '.tabbed-content-row' ).slideUp( 300 );
			jQuery( this ).addClass( 'active' );
			jQuery( this )
				.siblings( '.tabbed-content-row' )
				.slideDown( 300 );
		}
	} );

	/**
	 *
	 * * Header form
	 *
	 *
	 */

	jQuery( document ).on( 'click', function( e ) {
		if ( ! jQuery( e.target ).closest( '.header-search-form' ).length ) {
			jQuery( '.header-search-form' ).removeClass( 'show' );
		}
	} );

	jQuery( '.js-search-open' ).on( 'click', function( e ) {
		e.stopPropagation();
		jQuery( this ).prev( '.header-search-form' ).addClass( 'show' );
	} );

	jQuery( '.js-search-close' ).on( 'click', function() {
		jQuery( this ).closest( '.header-search-form' ).removeClass( 'show' );
	} );

	/**
	 *
	 * 	* Script for Add class external link
	 *
	 */

	const extLink = jQuery( 'body a' ).filter( function() {
		return this.hostname && this.hostname !== location.hostname;
	} );
	extLink.each( function() {
		jQuery( this ).attr( 'target', '_blank' );
		jQuery( this ).addClass( 'external-link' );
	} );

	jQuery( '#platform-mega-menu' ).appendTo( '.mega-menu-platform' );

	/**   - script for team */

	/**
	 *
	 * * Team Member popup
	 *
	 *
	 */

	jQuery( '.team-member' ).each( function() {
		const disCount = jQuery( this ).find( '.member-desc' ).text().split( '' ).length;
		if ( disCount > 399 ) {
			jQuery( this ).find( '.member-btn' ).find( '.button' ).removeClass( 'slide-down' );
			jQuery( this ).find( '.member-btn' ).find( '.button' ).addClass( 'have-popup' );
		} else {
			jQuery( this ).find( '.member-btn' ).find( '.button' ).addClass( 'slide-down' );
			jQuery( this ).find( '.member-btn' ).find( '.button' ).removeClass( 'have-popup' );
		}
	} );

	jQuery( '.member-btn button.slide-down' ).on( 'click', function() {
	    const $button = jQuery( this );
	    const $memberDesc = $button.parents( '.team-member' ).find( '.member-desc' );
	    $memberDesc.slideToggle();

	    const $inner = $button.find( '.inner' );
	    const innerText = $inner.text();

	    if ( innerText === 'Show more' ) {
	        $inner.text( 'Show less' );
	    } else {
	        $inner.text( 'Show more' );
	    }
	} );

	jQuery( '.member-btn .have-popup' ).on( 'click', function() {
		jQuery( '.team-popup,.popup-bg' ).removeClass( 'show' );
		jQuery( 'body,.popup-bg' ).removeClass( 'show' );
		const id = jQuery( this ).attr( 'href' );
		jQuery( id ).addClass( 'show' );
		jQuery( 'body,.popup-bg' ).addClass( 'show' );
	} );

	jQuery( document ).mouseup( function( e ) {
		const container = jQuery( '.team-popup' );
		// if the target of the click isn't the container nor a descendant of the container
		if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
			jQuery( '.team-popup,.popup-bg' ).removeClass( 'show' );
			jQuery( 'body' ).removeClass( 'show' );
		}
	} );

	jQuery.noConflict();

	jQuery( '.popup-member-close' ).on( 'click', function() {
		jQuery( '.team-popup,.popup-bg' ).removeClass( 'show' );
		jQuery( 'body' ).removeClass( 'show' );
	} );

	jQuery.noConflict();

	/**
	 * Theme Quote Owl Carousel Slider
	 */

	jQuery( '.js-arrows-quote' ).owlCarousel( {
		nav: true,
		dots: false,
		items: 1,
	} );

	jQuery( '.theme-quotes' ).owlCarousel( {
		margin: 126,
		nav: false,
		dots: true,
		autoplay: true,
		loop: true,
		autoplayTimeout: 8000,
		items: 1,
	} );

	/**
	 * Footer CTA Slider
	 */

	jQuery( '.cta-slider' ).owlCarousel( {
		loop: true,
		margin: 12,
		nav: false,
		dots: false,
		autoplay: true,
		items: 2,
		slideTransition: 'linear',
		autoplayTimeout: 4000,
		autoplaySpeed: 4000,
		mouseDrag: false,
		stagePadding: 70,
		autoWidth: true,
		pauseOnDotsHover: false,
		center: true,
	} );

	if ( jQuery( window ).width() < 1003 ) {
		jQuery( '.cta-slide' ).owlCarousel( {
			loop: true,
			margin: 10,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 4000,
			autoplaySpeed: 4000,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			center: true,
		} );
	}

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( '.js-resources-slider' ).owlCarousel( {
			margin: 24,
			nav: true,
			dots: false,
			item: 3,
		} );
	}

	// accessible sub menu
	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.mega-menu.sub-menu' ).addClass( 'focused' );
		} );

	jQuery( '.menu-item' ).not( '.menu-item-has-children' ).find( 'a' )
		.focus( function() {
			jQuery( '.mega-menu.sub-menu' ).removeClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	jQuery( '.js-logos-scroll' ).slick( {
		arrows: false,
		variableWidth: true,
		speed: 3000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
		infinite: true,
		centerMode: false,
	} );

	jQuery( '.js-mongoose-slider' ).slick( {
		arrows: false,
		variableWidth: true,
		speed: 5000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
		infinite: true,
		pauseOnDotsHover: false,
	} );

	jQuery.noConflict();

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.cta-logos ' ).owlCarousel( {
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 1500,
			autoplaySpeed: 1500,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			margin: 16,
			pauseOnDotsHover: false,
			centerMode: true,
		} );

		jQuery( '.show-at-desktop ' ).owlCarousel( {
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 4000,
			autoplaySpeed: 4000,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			margin: 50,
			pauseOnDotsHover: false,
			center: true,

		} );

		jQuery( '.cta-slide-reverse' ).owlCarousel( {
			loop: true,
			margin: 10,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 4000,
			autoplaySpeed: 4000,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			pauseOnDotsHover: false,
			rtl: true,
			center: true,

		} );
	}

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( '.js-quote-grid-slider ' ).owlCarousel( {
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 4000,
			autoplaySpeed: 4000,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			autoplayHoverPause: true,
		} );

		jQuery( '.reverse-slide' ).owlCarousel( {
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 4000,
			autoplaySpeed: 4000,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			rtl: true,
			autoplayHoverPause: true,
		} );
	}

	/**
	 *
	 * * Theme quote arrows
	 *
	 *
	 */

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( '.platform-nav' ).on( 'init', function( event, slick ) {
			jQuery( '.platform-nav .slick-slide.slick-current' ).addClass(
				'is-active'
			);
		} ).slick( {
			slidesToShow: 4,
			slidesToScroll: 4,
			dots: false,
			arrows: false,
			touchThreshold: 100,
			variableWidth: true,
			focusOnSelect: false,
			speed: 300,
			autoWidth: true,
			autoplay: true,
			autoplaySpeed: 8000,
			pauseOnHover: false,

		} );

		jQuery( '.platform-content' ).slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			touchThreshold: 100,
			fade: true,
			speed: 400,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 8000,
			pauseOnHover: false,
			dots: false,
			arrows: false,
		} );

		jQuery( '.platform-content' ).on(

			'afterChange',
			function( event, slick, currentSlide ) {
				jQuery( '.platform-nav' ).slick( 'slickGoTo', currentSlide );
				const currrentNavSlideElem =
					'.platform-nav .slick-slide[data-slick-index="' +
					currentSlide +
					'"]';
				jQuery( '.platform-nav .slick-slide.is-active' ).removeClass(
					'is-active'
				);
				jQuery( currrentNavSlideElem ).addClass( 'is-active' );
			}
		);

		jQuery( '.platform-nav' ).on( 'click', '.slick-slide', function( event ) {
			event.preventDefault();
			const goToSingleSlide = jQuery( this ).data( 'slick-index' );

			jQuery( '.platform-content' ).slick( 'slickGoTo', goToSingleSlide );
		} );
	}

	// /**
	//  *
	//  * * Theme quote arrows
	//  *
	//  *
	//  */

	jQuery( '.sc-one' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.sc-two',
		arrows: true,
		dots: false,
		focusOnSelect: true,
		infinite: false,
		adaptiveHeight: true,
	} );

	jQuery( '.sc-two' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.sc-one',
		dots: false,
		arrows: false,
		infinite: false,
		fade: true,
		adaptiveHeight: true,
	} );

	// jQuery.noConflict();

	if ( jQuery( '#progressBar, #progressBar2' ).length > 0 ) {
		function progressBarScroll() {
			const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
			const bodyHeight = document.documentElement.clientHeight;
			const footerHeight = jQuery( '#footer-section' ).outerHeight() || 0; // Get the height of the footer

			const height = document.documentElement.scrollHeight - bodyHeight - footerHeight; // Subtract footer height
			const scrolled = ( winScroll / height ) * 100;
			document.getElementById( 'progressBar' ).style.width = scrolled + '%';
			document.getElementById( 'progressBar2' ).style.width = scrolled + '%';
		}

		window.onscroll = function() {
			progressBarScroll();
		};
	}
	jQuery.noConflict();

	/**
	 *
	 * gravity form label up down on focus
	 *
	 */

	jQuery( 'input[type="text"],input[type="email"],input[type="tel"],textarea' ).each( function() {
		jQuery( this ).on( 'focus', function() {
			jQuery( this ).parent().parent( '.gfield' ).addClass( 'active' );
		} );
		jQuery( this ).on( 'blur', function() {
			if ( jQuery( this ).val().length == 0 ) {
				jQuery( this ).parent().parent( '.gfield' ).removeClass( 'active' );
			}
		} );
		if ( jQuery( this ).val() != '' ) {
			jQuery( this ).parent( '.css' ).addClass( 'active' );
		}
	} );

	jQuery.noConflict();

	/**
	 *
	 * Hubspot form label up down on focus
	 *
	 */

	setTimeout( () => {
		jQuery( 'input[type="text"],input[type="email"],input[type="tel"],textarea' ).each( function() {
			jQuery( this ).on( 'focus', function() {
				jQuery( this ).parent().parent( '' ).addClass( 'active' );
			} );
			jQuery( this ).on( 'blur', function() {
				if ( jQuery( this ).val().length == 0 ) {
					jQuery( this ).parent().parent( '' ).removeClass( 'active' );
				}
			} );
			if ( jQuery( this ).val() != '' ) {
				jQuery( this ).parent( '.css' ).addClass( 'active' );
			}
		} );
	}, 500 );

	jQuery.noConflict();

	/**
	 *
	 * * Tabbed Content
	 *
	 */

	jQuery( '.tabbed-content' ).organicTabs( {
		speed: 200,
	} );

	/**
	 *
	 * * Lead paragraph Fancy
	 *
	 */

	if ( jQuery( '.leadpara-item' ).length > 0 ) {
		const leadParaItems = document.querySelectorAll( '.leadpara-item' );

		leadParaItems.forEach( ( item, index ) => {
			gsap.to( item, {
				scrollTrigger: {
					trigger: item,
					start: 'top center',
					endTrigger: item,
					end: 'bottom center',
					scrub: true,
					pin: false,
					onEnter: () => item.classList.add( 'active' ),
					// onLeaveBack: () => item.classList.remove('active'),
				},
				duration: 1,
			} );
		} );
	}

	// Scrolling text

	if ( jQuery( window ).width() > 1003 ) {
		gsap.registerPlugin( ScrollTrigger );
		if ( jQuery( '.js-scroll-row' ).length > 3 ) {
			const cards = gsap.utils.toArray( '.js-scroll-row' );
			const spacer = 5;
			const minScale = 0.9;
			const distributor = gsap.utils.distribute( { base: minScale, amount: 0.15 } );

			cards.forEach( ( card, index ) => {
				const increment = index + 1;
				const scaleVal = distributor( index, cards[ index ], cards );

				const tween = gsap.to( card, {
					scrollTrigger: {
						trigger: card,
						start: `top 90px  top 20%`,
						scrub: 1,
						// markers: true,
						endTrigger: '.container2',
						end: `bottom top+=${ 654 + ( cards.length * spacer ) }`,
						pin: true,
						pinSpacing: false,
						onEnter: () => {
							jQuery( '#scroller-content-' + increment ).addClass( 'active' );
							jQuery( '.scroller-indicator' ).removeClass( 'active' );
							jQuery( '.scroller-indicator-' + increment ).addClass( 'active' );
						},
						onLeaveBack: () => {
							jQuery( '#scroller-content-' + increment ).removeClass( 'active' );
							jQuery( '.scroller-indicator' ).removeClass( 'active' );
							jQuery( '.scroller-indicator-' + increment ).addClass( 'active' );
						},
					},
					ease: 'linear',
					scale: scaleVal,
				} );

				// gsap.set(card, { top: '130px' });
			} );
			if ( jQuery( '.scroller-indicators' ).length > 0 ) {
				gsap.to( '.scroller-indicators', {
					scrollTrigger: {
						trigger: '.scroller-indicators',
						start: `center center`,
						scrub: 2,
						endTrigger: '.scroller-ctn',
						end: `bottom top+=${ 654 + ( cards.length * spacer ) }`,
						pin: true,
						pinSpacing: false,
					},
					ease: 'linear',
				} );
			}
		} else {
			const cards = gsap.utils.toArray( '.js-scroll-row' );
			const spacer = 5;
			const minScale = 0.9;
			const distributor = gsap.utils.distribute( { base: minScale, amount: 0.05 } );

			cards.forEach( ( card, index ) => {
				const increment = index + 1;
				const scaleVal = distributor( index, cards[ index ], cards );

				const tween = gsap.to( card, {
					scrollTrigger: {
						trigger: card,
						start: `top 90px  top 20%`,
						scrub: 1,
						// markers: true,
						endTrigger: '.container2',
						end: `bottom top+=${ 654 + ( cards.length * spacer ) }`,
						pin: true,
						pinSpacing: false,
						onEnter: () => {
							jQuery( '#scroller-content-' + increment ).addClass( 'active' );
							jQuery( '.scroller-indicator' ).removeClass( 'active' );
							jQuery( '.scroller-indicator-' + increment ).addClass( 'active' );
						},
						onLeaveBack: () => {
							jQuery( '#scroller-content-' + increment ).removeClass( 'active' );
							jQuery( '.scroller-indicator' ).removeClass( 'active' );
							jQuery( '.scroller-indicator-' + increment ).addClass( 'active' );
						},
					},
					ease: 'linear',
					scale: scaleVal,
				} );

				// gsap.set(card, { top: '130px' });
			} );

			if ( jQuery( '.scroller-indicators' ).length > 0 ) {
				gsap.to( '.scroller-indicators', {
					scrollTrigger: {
						trigger: '.scroller-indicators',
						start: `center center`,
						scrub: 2,
						endTrigger: '.scroller-ctn',
						end: `bottom top+=${ 654 + ( cards.length * spacer ) }`,
						pin: true,
						pinSpacing: false,
					},
					ease: 'linear',
				} );
			}
		}
	}

	// Iat image

	// gsap.registerPlugin( ScrollTrigger );
	if ( jQuery( window ).width() > 1003 ) {
		if ( jQuery( '.js-iat-image' ).length > 0 ) {
			gsap.to( '.js-iat-image', {
				y: '-150px',
				ease: 'power1.out',
				scrollTrigger: {
					trigger: '.js-iat-image',
					start: 'top -40% bottom',
					end: 'top -70%  top',
					scrub: true,
					// markers: true,
				},
			} );
		}
		// Iat Content
		if ( jQuery( '.js-iat-quote-content' ).length > 0 ) {
			gsap.to( '.js-iat-quote-content', {
				y: '-150px',
				ease: 'power1.out',
				scrollTrigger: {
					trigger: '.js-iat-quote-content',
					start: 'top 80% bottom',
					end: 'top 40% top',
					scrub: true,
				},
			} );
		}
	}

	// script for progress bar for owl dots
	const progressbarCircle = `<svg class="active" width="24px" height="24px" viewBox="0 0 24 24" preserveAspectRatio="none">
		  <circle cx="12" cy="12px" r="10" stroke="#37BA95" stroke-width="1.5" fill="white" />
		</svg>`;

	jQuery( '.theme-quotes  .owl-dots  .owl-dot' ).each( function() {
		jQuery( this ).prepend( '<div class="svg-container">' + progressbarCircle + '</div>' );
	} );

	/**
	 *
	 * 	* Script for stats animation
	 *
	 */

	const a = [];
	function isElementInViewport( el ) {
		const rect = el.getBoundingClientRect();
		return rect.top >= 0 && rect.left >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) && rect.right <= ( window.innerWidth || document.documentElement.clientWidth );
	}
	if ( jQuery( '.stat-heading' ).length > 0 ) {
		jQuery( window ).scroll( function() {
			jQuery( '.stat-heading' ).each( function( index ) {
				if ( ! a[ index ] && isElementInViewport( this ) ) {
					jQuery( this ).find( '.number' ).each( function() {
						const $this = jQuery( this ),
							countTo = $this.attr( 'data-number' );
						jQuery( {
							countNum: $this.text(),
						} ).animate( {
							countNum: countTo,
						}, {
							duration: 2000,
							easing: 'swing',
							step() {
								$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
							},
							complete() {
								$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
							},
						} );
					} );
					a[ index ] = true;
				}
			} );
		} );
	}

	jQuery.noConflict();

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.hero-plan:nth-child(1) .js-plan-all-features' ).text( 'Show Less' );
		jQuery( '.hero-plan:nth-child(1) .js-plan-all-features' ).addClass( 'show-less-button' );

		jQuery( '.js-plan-all-features' ).click( function() {
			const heroPlan = jQuery( this ).parents( '.hero-plan' );
			jQuery( this ).toggleClass( 'show-less-button' );
			heroPlan.find( '.plan-detail' ).slideToggle();

			if ( jQuery( this ).text() === 'All Features' ) {
				jQuery( this ).text( 'Show Less' );
			} else {
				jQuery( this ).text( 'All Features' );
			}
		} );
	}
} );

jQuery( document ).ready( function() {
	jQuery( '.mega-menu-platform' ).each( function() {
		const html = jQuery( 'ul.mega-menu' ).html();
		const classes = jQuery( 'ul.mega-menu' ).attr( 'class' );
		const id = jQuery( 'ul.mega-menu' ).attr( 'id' );
		jQuery( 'ul.mega-menu' ).remove();
		jQuery( '.submenu-icon' ).remove();
		jQuery( this ).append( '<div  id="' + id + '" class="' + classes + '">' + html + '</div>' );
	} );

	jQuery( '.mega-menu-platform' ).find( '.menu-item-child' ).each( function() {
		if ( jQuery( this ).hasClass( 'current-menu-item' ) ) {
			jQuery( '.mega-menu-platform' ).addClass( 'current-menu-parent' );
		}
	} );

	if ( jQuery( window ).width() > 1003 ) {
		if ( jQuery( '.gravity__content__bottom'.length > 0 ) ) {
			new AnimationScroll( {
				selector: '.gravity__content__bottom',
				onLoad: false,
				onscroll: true,
				trigger: 0,
				transform: '0',
				// draggable: true,
				gravity: {
					selector: '.applyGravity',
					containerSelector: '.gravity__content__bottom',
					speed: 0.1,
					transform: '15xvw',
					duration: 1,
					// draggable: true,
				},
			} );
		}
	}

	if ( jQuery( window ).width() > 1180 && ! jQuery( '.page-template-template-demo' ).length ) {
		gsap.to( '.main-section', {
			scale: 0.9,
			ease: 'none',
			duration: 1,
			scrollTrigger: {
				trigger: '.scroll-trigger-animate',
				start: 'bottom bottom 300px',
				end: '+=100%',
				scrub: 1,
				// markers: true,
				onEnter: () => {
					jQuery( '.main-section' ).removeClass( 'animation-on' );
					jQuery( '.hero-jumplinks-bar' ).addClass( 'hide-bar' );
				},
				onLeaveBack: () => {
					jQuery( '.main-section' ).addClass( 'animation-on' );
					jQuery( '.hero-jumplinks-bar' ).removeClass( 'hide-bar' );
				},
			},
		} );
	}
	if ( jQuery( window ).width() > 1180 && ! jQuery( '.page-template-template-demo' ).length ) {
		gsap.to( '.footer-section', {
			zIndex: 0,
			ease: 'none',
			scrollTrigger: {
				trigger: '.scroll-trigger-animate',
				start: 'bottom bottom 300px',
				end: '+=90%',
				scrub: 1,
			},
		} );
	}
} );

